/**
 * @generated SignedSource<<80a76182ffe7fe41e7ab5ed5df2584ab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamHeader_team$data = {
  readonly canEdit: boolean;
  readonly color: string | null;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"TeamHeaderRoles_team" | "TeamPickerButton_team" | "TeamSettingsPopover_Team">;
  readonly " $fragmentType": "TeamHeader_team";
};
export type TeamHeader_team$key = {
  readonly " $data"?: TeamHeader_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamHeader_team">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamHeader_team",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamPickerButton_team"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamHeaderRoles_team"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canEdit",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamSettingsPopover_Team"
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "4ff60df3188d3445a862a52ae6b5c181";

export default node;
